import { Controller } from "react-hook-form";
import { Input } from "antd";
const { Search } = Input;


 const InputSearchControl = ({
  name,
  control,
  errors,
  isDisabled = false,
  placeholder = "",
  className = "",
}) => {
  let errMsg = errors?.[name]?.message;
  return (
    <div className="relative">
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Search
            allowClear
            {...field}
            id={name}
            className={`rounded my-1 py-2 ${className}`}
            status={errMsg && "error"}
            size="large"
            disabled={isDisabled}
            placeholder={placeholder}
          />
        )}
      />
      <p className="text-red-600 text-xs absolute font-light">{errMsg}</p>
    </div>
  );
};

export default InputSearchControl;
